import Filter from './Filter'
import { FullTextSearchManager } from './FullTextSearchManager'

class TextFieldFilter extends Filter {
    fullText: boolean
    fullTextSearchManager?: FullTextSearchManager

    input: JQuery

    constructor(filterView: JQuery) {
        super()

        const initialValue = filterView.data('initial-value') || ['']
        if (initialValue?.length) {
            this.value = [initialValue[0].toLowerCase()]
        } else {
            this.value = ['']
        }

        this.fullText = filterView.data('full-text') || false

        if (this.fullText) {
            this.fullTextSearchManager = new FullTextSearchManager(
                filterView.data('full-text-endpoint'),
            )
        }

        this.type = 'contains'

        this.input = filterView.find('input')

        this.input.val(initialValue[0])

        let handler = null
        this.input.on('input', () => {
            clearTimeout(handler)
            handler = setTimeout(() => {
                const text = this.input.val() as string
                this.value = [text.toLowerCase()]
                this.onFilterChange()
            }, 500)
        })
    }

    async matches(post: PostItem, categories: string[]): Promise<boolean> {
        if (this.fullText) {
            return await this.fullTextSearchManager.matches(
                this.value[0],
                post.id,
            )
        }
        return super.matches(post, categories)
    }

    reset() {
        this.value = ['']
        this.input.val('')
    }
}

export default TextFieldFilter
